// Copyright (c) 2026 Vigeos SASU. Tous droits réservés.
// Miroir de compte_famille.DUMMY_DOMAINS (backend) : domaines réservés par
// les RFC 2606 et 6761, où aucun courriel n'est jamais remis. Le SMTP accepte
// pourtant le message : un mot de passe envoyé là changerait pour une boîte que
// personne ne lit (le compte de démonstration de la prod est à example.com).
// Le serveur refuse ces adresses en 409 ; le dashboard le signale avant le
// clic. Un compte de démonstration se gère dans le conteneur backend
// (python -m app.tools.compte_demo_famille).
const DUMMY_DOMAINS = ['example.com', 'example.net', 'example.org', 'example', 'test', 'invalid', 'localhost'];
export function isDummyAddress(email) {
  const domain = (email || '').split('@').pop().trim().replace(/\.$/, '').toLowerCase();
  return !!domain && DUMMY_DOMAINS.some(d => domain === d || domain.endsWith(`.${d}`));
}
